var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "header",
      {
        staticClass:
          "modal-header py25 px65 h1 sans-serif weight-700 bg-cl-secondary"
      },
      [
        _vm._v("\n    " + _vm._s(_vm.$t("Reset password")) + "\n    "),
        _c(
          "i",
          {
            staticClass: "modal-close material-icons cl-bg-tertiary",
            attrs: { slot: "close" },
            on: { click: _vm.close },
            slot: "close"
          },
          [_vm._v("\n      close\n    ")]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal-content bg-cl-primary pt30 pb60 px65 cl-secondary"
      },
      [
        !_vm.passwordSent
          ? [
              _c(
                "form",
                {
                  attrs: { novalidate: "" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.sendEmail($event)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "mb20" },
                    [
                      _c("p", { staticClass: "mb45" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "Enter your email to receive instructions on how to reset your password."
                              )
                            ) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("base-input", {
                        attrs: {
                          type: "email",
                          name: "email",
                          focus: "",
                          placeholder: _vm.$t("E-mail address *"),
                          validations: [
                            {
                              condition:
                                !_vm.$v.email.required && _vm.$v.email.$error,
                              text: _vm.$t("Field is required.")
                            },
                            {
                              condition:
                                !_vm.$v.email.email && _vm.$v.email.$error,
                              text: _vm.$t(
                                "Please provide valid e-mail address."
                              )
                            }
                          ]
                        },
                        model: {
                          value: _vm.email,
                          callback: function($$v) {
                            _vm.email = $$v
                          },
                          expression: "email"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button-full",
                    { staticClass: "mb35", attrs: { type: "submit" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("Reset password")) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "center-xs" }, [
                    _vm._v(
                      "\n          " + _vm._s(_vm.$t("or")) + "\n          "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.switchElem($event)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("return to log in")) +
                            "\n          "
                        )
                      ]
                    )
                  ])
                ],
                1
              )
            ]
          : _vm._e(),
        _vm._v(" "),
        _vm.passwordSent
          ? [
              _c(
                "div",
                { staticClass: "modal-content pt30 pb60 px65 cl-secondary" },
                [
                  _c(
                    "form",
                    {
                      attrs: { novalidate: "" },
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.confirmReset($event)
                        }
                      }
                    },
                    [
                      _c("p", { staticClass: "mt0 mb40" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "We've sent a verification code to your email. Check your inbox and set new password"
                              )
                            ) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("base-input", {
                        staticClass: "mb10",
                        attrs: {
                          type: "email",
                          name: "email",
                          focus: "",
                          placeholder: _vm.$t("E-mail address *"),
                          validations: [
                            {
                              condition:
                                !_vm.$v.email.required && _vm.$v.email.$error,
                              text: _vm.$t("Field is required.")
                            },
                            {
                              condition:
                                !_vm.$v.email.email && _vm.$v.email.$error,
                              text: _vm.$t(
                                "Please provide valid e-mail address."
                              )
                            }
                          ]
                        },
                        model: {
                          value: _vm.email,
                          callback: function($$v) {
                            _vm.email = $$v
                          },
                          expression: "email"
                        }
                      }),
                      _vm._v(" "),
                      _c("base-input", {
                        staticClass: "mb10",
                        attrs: {
                          type: "password",
                          name: "verificationCode",
                          placeholder: _vm.$t("Verification code *"),
                          validations: [
                            /*{
            condition: !$v.activation_code.required && $v.activation_code.$error,
            text: $t('Field is required.')
          }*/
                          ]
                        },
                        model: {
                          value: _vm.verificationCode,
                          callback: function($$v) {
                            _vm.verificationCode = $$v
                          },
                          expression: "verificationCode"
                        }
                      }),
                      _vm._v(" "),
                      _c("base-input", {
                        staticClass: "mb10",
                        attrs: {
                          type: "password",
                          name: "password",
                          placeholder: _vm.$t("Password *"),
                          validations: [
                            /*{
            condition: !$v.password.required && $v.password.$error,
            text: $t('Field is required.')
          }*/
                          ]
                        },
                        model: {
                          value: _vm.password,
                          callback: function($$v) {
                            _vm.password = $$v
                          },
                          expression: "password"
                        }
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "mt0 mb40" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "Password must contain at least 8 characters (at least 1 special character, 1 uppercase letter, 1 lowercase letter, 1 number)."
                              )
                            ) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("base-input", {
                        staticClass: "mb10",
                        attrs: {
                          type: "password",
                          name: "new-password",
                          placeholder: _vm.$t("Repeat password *"),
                          validations: [
                            /*{
            condition: !$v.rPassword.required && $v.rPassword.$error,
            text: $t('Field is required.')
          },
          {
            condition: !$v.rPassword.sameAsPassword && $v.rPassword.$error,
            text: $t('Passwords must be identical.')
          }*/
                          ]
                        },
                        model: {
                          value: _vm.rPassword,
                          callback: function($$v) {
                            _vm.rPassword = $$v
                          },
                          expression: "rPassword"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-sm-6" }, [
                          _c(
                            "a",
                            {
                              staticClass:
                                "btn btn--dark-blue btn--medium btn--block",
                              attrs: {
                                href: "#",
                                "data-testid": "registerLink"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.switchElem($event)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("Cancel")) +
                                  "\n              "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-6" },
                          [
                            _c(
                              "button-full",
                              {
                                staticClass:
                                  "mb20 btn btn--orange btn--medium btn--block",
                                attrs: {
                                  type: "submit",
                                  "data-testid": "loginSubmit"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("Reset password")) +
                                    "\n              "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ]
              )
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }